export const DEFAULT_COLOR = "#000000";
export const KPI_REVIEW_CONFIG_NAME = "kpi_configuration";

export const THRESHOLD = { value: "threshold", label: "Threshold" };
export const RUNRATE = { value: "runRate", label: "RunRate" };
export const RANGE = { value: "range", label: "Range" };
export const COMPARISON = { value: "comparison", label: "Comparison" };

export const EQUAL = "equal";
export const LESS = "less";
export const GREATER = "greater";
export const SUCCESS = "success";
export const FAILURE = "failure";
export const THEME = "#23C6B1";

export const ID_TO_NAME_MAPPING : Record<string,any>= {
  salesValue: {
    sales_value: "Sales Value %",
    prd_ach: "Month Achievement",
    prd_tgt: "Month Target",
    qtr_ach_per: "Quarter Achievement %",
    qtr_tgt: "Quarter Target"
  },
  visitCompliance: {
    visit_compliance_per: "Visit Compliance %",
    plannedCall: "Planned Call",
    actualCall: "Actual Call",
    ptdMissed: "PTD Missed",
    l8WMissed: "Last 8 Weeks Missed"
  },
  eco: {
    eco_per: "Eco Percent",
    totalOutlet: "Total Outlet",
    billedOutlet: "Billed Outlet"
  },
  productiveCall: {
    productive_call: "Productive Call %",
    totalCall: "Total Calls",
    daysPassed: "Days Passed",
    productiveCall: "Productive Calls",
    daysWith70perTGTAch: "Days with 70% TGT Ach"
  }
};



export const CARD_PREVIEW_DUMMY_DATA: Record<string,any> = {
  salesValue: {
    sales_value: "75",
    prd_ach: "100K",
    prd_tgt: "120K",
    qtr_ach_per: "85%",
    qtr_tgt: "500K"
  },
  productiveCall: {
    productive_call: "78",
    totalCall: "150",
    daysPassed: "20",
    productiveCall: "120",
    daysWith70perTGTAch: "15"
  },
  visitCompliance: {
    visit_compliance_per: "95",
    plannedCall: "180",
    actualCall: "170",
    ptdMissed: "10",
    l8WMissed: "5"
  },
  eco: {
    eco_per: "82",
    totalOutlet: "50",
    billedOutlet: "45"
  }
};



export const SUMMARY_CARD_DUMMY_DATA: Record<string,any> = {
    sales_value_user: {
      sales_ach: "85",
      totalOutletCount: 100,
      outletWith100perTGTAch: 80,
      totalNoOrderOutletCount: 20
    },
    productive_user_period_outlet: {
      productive_ach: "82",
      totalCall: 150,
      daysPassed: 20,
      productiveCall: 120,
      daysWith70perTGTAch: 15
    },
    productive_user_period_day: {
      productive_ach: "88",
      daysPassed: 22,
      daysWith70perPTDAch: 18,
      daysWith70perMissedPTD: 4
    },
    msl_user: {
      msl_ach: "78",
      totalOutlet: 50,
      totalMsl: 40
    },
    visit_compliance_lw_not_visited: {
      visit_compliance_per: "75",
      actualVisit: 60,
      plannedVisit: 80,
      missedVisit: 20
    },
    visit_compliance_ptd_not_visited: {
      visit_compliance_per: "80",
      actualVisit: 70,
      plannedVisit: 85,
      missedVisit: 15
    },
    eco_sm_card: {
      eco_compliance_per: "77",
      totalOutlet: 90,
      billedOutlet: 65,
      notBilledOutlet: 25
    
  }
  
  
}

export const TABLE_DUMMY_DATA: Record<string, any> = {
  sales_value_outlet_list: [
    {
      outletName: "City Supermarket",
      prdTgt: "6000",
      ptdAch: "5800",
      achPer: "97%",
    },
    {
      outletName: "Grocery Hub",
      prdTgt: "7200",
      ptdAch: "7050",
      achPer: "98%",
    },
    {
      outletName: "Fresh Mart",
      prdTgt: "5000",
      ptdAch: "4750",
      achPer: "95%",
    },
    {
      outletName: "Neighborhood Store",
      prdTgt: "6800",
      ptdAch: "6500",
      achPer: "95.6%",
    },
    {
      outletName: "Quick Stop Shop",
      prdTgt: "5500",
      ptdAch: "5300",
      achPer: "96.4%",
    },
  ],
  sales_value_brand_list: [
    {
      brandName: "Fresh Farms",
      avgL3Ach: "92%",
      ptdAch: "90%",
    },
    {
      brandName: "Nature's Bounty",
      avgL3Ach: "88%",
      ptdAch: "85%",
    },
    {
      brandName: "Organic Earth",
      avgL3Ach: "95%",
      ptdAch: "93%",
    },
    {
      brandName: "Green Valley",
      avgL3Ach: "90%",
      ptdAch: "89%",
    },
    {
      brandName: "Sunshine Harvest",
      avgL3Ach: "87%",
      ptdAch: "86%",
    },
  ],
  sales_value_channel_list: [
    {
      channel: "Retail Chain",
      prdTgt: "10000",
      ptdAch: "9200",
      achPer: "92%",
      avgL3Ach: "90%",
      grPer: "2%",
    },
    {
      channel: "Online Store",
      prdTgt: "8000",
      ptdAch: "7500",
      achPer: "93.75%",
      avgL3Ach: "92%",
      grPer: "1.5%",
    },
    {
      channel: "Wholesale",
      prdTgt: "12000",
      ptdAch: "11500",
      achPer: "95.83%",
      avgL3Ach: "94%",
      grPer: "1.8%",
    },
    {
      channel: "Local Market",
      prdTgt: "7000",
      ptdAch: "6800",
      achPer: "97.14%",
      avgL3Ach: "96%",
      grPer: "1.2%",
    },
    {
      channel: "Direct Sales",
      prdTgt: "5000",
      ptdAch: "4800",
      achPer: "96%",
      avgL3Ach: "93%",
      grPer: "1.7%",
    },
  ],
  sales_value_range_list: [
    {
      range: "Low",
      ptdAch: "70%",
      avgL3Ach: "68%",
    },
    {
      range: "Medium",
      ptdAch: "85%",
      avgL3Ach: "83%",
    },
    {
      range: "High",
      ptdAch: "90%",
      avgL3Ach: "88%",
    },
    {
      range: "Premium",
      ptdAch: "95%",
      avgL3Ach: "92%",
    },
    {
      range: "Exclusive",
      ptdAch: "98%",
      avgL3Ach: "95%",
    },
  ],
  productive_call_outlet_list: [
    {
      outletName: "City Supermarket",
      lastBilledOn: "2023-09-15",
      lastPlannedDate: "2023-09-20",
    },
    {
      outletName: "Grocery Hub",
      lastBilledOn: "2023-09-10",
      lastPlannedDate: "2023-09-17",
    },
    {
      outletName: "Fresh Mart",
      lastBilledOn: "2023-09-12",
      lastPlannedDate: "2023-09-18",
    },
    {
      outletName: "Neighborhood Store",
      lastBilledOn: "2023-09-08",
      lastPlannedDate: "2023-09-16",
    },
    {
      outletName: "Quick Stop Shop",
      lastBilledOn: "2023-09-11",
      lastPlannedDate: "2023-09-19",
    },
  ],
  productive_call_day_list: [
    {
      totalOutletCount: 150,
      productiveCall: 120,
      totalCall: 180,
    },
    {
      totalOutletCount: 200,
      productiveCall: 170,
      totalCall: 220,
    },
    {
      totalOutletCount: 180,
      productiveCall: 160,
      totalCall: 200,
    },
    {
      totalOutletCount: 160,
      productiveCall: 140,
      totalCall: 190,
    },
    {
      totalOutletCount: 190,
      productiveCall: 155,
      totalCall: 210,
    },
  ],
  msl_outlet_list: [
    {
      outletName: "City Supermarket",
      mslCountTgt: 50,
      mslCountAch: 45,
      achPer: "90%",
    },
    {
      outletName: "Grocery Hub",
      mslCountTgt: 40,
      mslCountAch: 38,
      achPer: "95%",
    },
    {
      outletName: "Fresh Mart",
      mslCountTgt: 55,
      mslCountAch: 50,
      achPer: "91%",
    },
    {
      outletName: "Neighborhood Store",
      mslCountTgt: 60,
      mslCountAch: 55,
      achPer: "92%",
    },
    {
      outletName: "Quick Stop Shop",
      mslCountTgt: 45,
      mslCountAch: 44,
      achPer: "98%",
    },
  ],
  visit_compliance_lw_list: [
    {
      outletName: "City Supermarket",
      outletCode: "CS001",
      lastVisitedOn: "2023-09-20",
      lastPlannedOn: "2023-09-25",
    },
    {
      outletName: "Grocery Hub",
      outletCode: "GH002",
      lastVisitedOn: "2023-09-18",
      lastPlannedOn: "2023-09-23",
    },
    {
      outletName: "Fresh Mart",
      outletCode: "FM003",
      lastVisitedOn: "2023-09-19",
      lastPlannedOn: "2023-09-24",
    },
    {
      outletName: "Neighborhood Store",
      outletCode: "NS004",
      lastVisitedOn: "2023-09-17",
      lastPlannedOn: "2023-09-22",
    },
    {
      outletName: "Quick Stop Shop",
      outletCode: "QS005",
      lastVisitedOn: "2023-09-16",
      lastPlannedOn: "2023-09-21",
    },
  ],
  visit_compliance_drill_down_list: [
    {
      outletName: "City Supermarket",
      outletCode: "CS001",
      lastVisitedOn: "2023-09-21",
      lastPlannedOn: "2023-09-28",
    },
    {
      outletName: "Grocery Hub",
      outletCode: "GH002",
      lastVisitedOn: "2023-09-20",
      lastPlannedOn: "2023-09-29",
    },
    {
      outletName: "Fresh Mart",
      outletCode: "FM003",
      lastVisitedOn: "2023-09-22",
      lastPlannedOn: "2023-09-30",
    },
    {
      outletName: "Neighborhood Store",
      outletCode: "NS004",
      lastVisitedOn: "2023-09-19",
      lastPlannedOn: "2023-09-27",
    },
    {
      outletName: "Quick Stop Shop",
      outletCode: "QS005",
      lastVisitedOn: "2023-09-18",
      lastPlannedOn: "2023-09-26",
    },
  ],
  eco_drill_down_list: [
    {
      outletName: "City Supermarket",
      outletCode: "CS001",
      lastBilledOn: "2023-09-15",
      notBilledSince: "2023-08-01",
      lastVisitedOn: "2023-09-20",
    },
    {
      outletName: "Grocery Hub",
      outletCode: "GH002",
      lastBilledOn: "2023-08-10",
      notBilledSince: "2023-07-05",
      lastVisitedOn: "2023-09-22",
    },
    {
      outletName: "Fresh Mart",
      outletCode: "FM003",
      lastBilledOn: "2023-09-12",
      notBilledSince: "2023-07-30",
      lastVisitedOn: "2023-09-19",
    },
    {
      outletName: "Neighborhood Store",
      outletCode: "NS004",
      lastBilledOn: "2023-08-20",
      notBilledSince: "2023-07-15",
      lastVisitedOn: "2023-09-21",
    },
    {
      outletName: "Quick Stop Shop",
      outletCode: "QS005",
      lastBilledOn: "2023-09-10",
      notBilledSince: "2023-08-05",
      lastVisitedOn: "2023-09-18",
    },
  ],
};

export const DEFAULT_KPI_TITLE: Record<string, string> = {
  salesValue: "Sales Value",
  productiveCall: "Productive Call",
  mslDistribution: "MSL Distribution",
  visitCompliance: "Visit Compliance",
  eco: "ECO",
};

export const ALLOWED_KPI_CONFIG_OPTIONS: string[] = [
  "salesValue",
  "mslDistribution",
  "productiveCall",
  "visitCompliance",
  "eco",
];

export const DEFAULT_PERVIEW_VALUE: Record<
  string,
  { value: number; label: string }
> = {
  prd_tgt: {
    value: 11000,
    label: "11k",
  },
  prd_ach: {
    value: 11000,
    label: "11k",
  },
  ptd_ach: {
    value: 32200,
    label: "32.2k",
  },
  qtr_tgt: {
    value: 50000,
    label: "50k",
  },
  qtr_ach_per: {
    value: 99,
    label: "99",
  },
  combined: {
    value: 40,
    label: "40",
  },
  totalCall: {
    value: 150,
    label: "150",
  },
  productiveCall: {
    value: 78,
    label: "78",
  },
  daysPassed: {
    value: 4,
    label: "4",
  },
  daysWith70perTGTAch: {
    value: 3,
    label: "3",
  },
  avg_line_sold: {
    value: 90,
    label: "90",
  },
};

export const COMPARATOR_MAP_FUNCTION: Record<
  string,
  (a: number, b: number) => boolean
> = {
  "=": (a: string | number, b: string | number) => Number(a) === Number(b),
  "!=": (a: string | number, b: string | number) => Number(a) !== Number(b),
  "<": (a: string | number, b: string | number) => Number(a) < Number(b),
  ">": (a: string | number, b: string | number) => Number(a) > Number(b),
  "<=": (a: string | number, b: string | number) => Number(a) <= Number(b),
  ">=": (a: string | number, b: string | number) => Number(a) >= Number(b),
};

export const COMPARISONS_OPERAND_OPTIONS_ID: Record<string, string[]> = {
  salesValue: ["prd_tgt", "ptd_ach", "qtr_tgt", "qtr_ach_per", "combined"],
  productiveCall: [
    "totalCall",
    "productiveCall",
    "daysPassed",
    "daysWith70perTGTAch",
    "combined",
  ],
};

export const DEFAULT_VALIDATION_VALUE: Record<string, Record<string, any>> = {
  runRate: {
    data: {
      type: "runRate",
      runRate: {
        ec: "#000000",
        gc: "#3fb154",
        lc: "#e94e4e",
      },
    },
  },
  threshold: {
    data: {
      type: "threshold",
      threshold: {
        ec: "#000000",
        gc: "#3fb154",
        lc: "#e94e4e",
        value: "30",
      },
    },
  },
  range: {
    data: {
      type: "range",
      range: [
        {
          color: "#3fb154",
          endValue: "max",
          startValue: "86.0",
        },
      ],
    },
  },
  comparison: {
    data: {
      type: "comparison",
      comparison: [
        {
          operand1: "",
          operand2: "",
          operation: "<",
          color: "#6aa84f",
          emoji: "neutral",
        },
      ],
    },
  },
  default: {
    data: {
      type: "",
    },
  },
};

export const TOGGLE_MAP_CARD: Record<string, Record<string, any>> = {
  salesValue: {
    default: "sales_value_user",
  },
  productiveCall: {
    outlet_toggle: "productive_user_period_outlet",
    day_toggle: "productive_user_period_day",
    default: "false",
  },
  mslDistribution: {
    default: "msl_user",
  },
  valueTieUp: {
    default: "value_tie_up",
  },
  salesVolume: {
    default: "sales_volume",
  },
  damages: {
    default: "trade_return",
  },
  visitCompliance: {
    lwNotVisited_toggle: "visit_compliance_lw_not_visited",
    ptdNotVisited_toggle: "visit_compliance_ptd_not_visited",
  },
  eco: {
    default: "eco_sm_card",
  },
  volumeTieUp: {
    default: "volume_tie_up",
  },
};

export const TOGGLE_MAP_TABLE: Record<string, Record<string, any>> = {
  salesValue: {
    outlet_toggle: "sales_value_outlet_list",
    brand_toggle: "sales_value_brand_list",
    channel_toggle: "sales_value_channel_list",
    range_toggle: "sales_value_range_list",
  },
  productiveCall: {
    outlet_toggle: "productive_call_outlet_list",
    day_toggle: "productive_call_day_list",
  },
  valueTieUp: {
    default: "value_tie_up_outlet_list",
  },
  salesVolume: {
    outlet_toggle: "sales_volume_outlet_list",
    brand_toggle: "sales_volume_brand_list",
    channel_toggle: "sales_volume_channel_list",
    range_toggle: "sales_volume_range_list",
  },
  damages: {
    outlet_toggle: "damages_trade_outlet_list",
  },
  visitCompliance: {
    lwNotVisited_toggle: "visit_compliance_lw_list",
    ptdNotVisited_toggle: "visit_compliance_drill_down_list",
  },
  eco: {
    ptdNotBilled_toggle: "eco_drill_down_list",
  },
  volumeTieUp: {
    default: "volume_tie_up_outlet_list",
  },
  mslDistribution: {
    default: "msl_outlet_list",
  },
};

export const ID_NAME_MAP: { [key: string]: string } = {
  salesValue: "Sales Value Percentage",
  prd_ach: "Period/Month Achivement",
  prd_tgt: "Period/Month Target",
  qtr_tgt: "Quarter Target",
  qtr_ach_per: "Quarter Achivement Percent",
  channel_toggle: "Channel Toggle",
  outlet_toggle: "Outlet Toggle",
  brand_toggle: "Brand Toggle",
  range_toggle: "Range Toggle",
  outletName: "Outlet Name",
  "Period/Month Target": "Target",
  mtdAch: "Period/Month Achivement",
  achPer: "Achivement Percentage",
  sales_value_user: "Sales Value Summary Card Heading",
  sales_ach: "Sales Value Percentage",
  totalOutletCount: "Total Outlet Count",
  outletWith100perTGTAch: "Outlet With 100% Target Ach",
  totalNoOrderOutletCount: "Total No Order Outlet Count",
  brandName: "Brand Name",
  avgL3Ach: "avg L3 Achievement",
  ptdAch: "Achievement",
  grPer: "Growth Percentage",
  productiveCallPercentage: "Productive Call Percentage",
  totalCall: "Total Call",
  daysPassed: "Days Passed",
  productiveCall: "Productive Call",
  daysWith70perTGTAch: "Days With 70% Target Achicement",
  day_toggle: "Day Toggle",
  productive_user_period_day: "Productive Call Summary Card Heading",
  daysWith70perPTDAch: "Days with 70% Achivement",
  lastBilledOn: "Last Billed On",
  lastPlannedDate: "Last Planned Date",
  msl_user: "MSL Distributon Summary Card Heading",
  msl_ach: "MSL Achivement",
  totalOutlet: "Total Outlet",
  totalMsl: "Total MSL",
  mslCountTgt: "MSL Count Target",
  mslCountAch: "MSL Count Achivement",
  productivityPercentage: "Productivity Percentage",
  avg_line_sold: "Average Line Sold",
  non_billed_outlets: "Non Billed Outlets",
  value_tie_up: "Value Tie UP Summary Heading",
  value_ach: "value Achivement",
  totalValueOutlets: "Total Value Outlets",
  valueTieUp100Ach: "Value Tie Up100% Achivement",
  totalTgt: "Total Target",
  ach: "Achivement",
  salesVolumePercentage: "Sales Volume Percentage",
  sales_volume: "Sales Volume Summary Card",
  sales_volume_sm_card_per: "Sales Volume Percentage",
  avgSaleL3P: "Avg Sale Last 3 Period",
  prdTGT: "Period/Month Target",
  "damages Percentage": "Damages Percentage",
  sales_val: "Sales Values",
  return_val: "Return Values",
  trade_return: "Damages Summary Card Heading",
  damage_sm_card_per: "Damages Percentage",
  salesOutlet: "Sales Outlets",
  returnOutlet: "Return Outlets",
  outletCode: "Outlet Code",
  prdAch: "Period/Month Achivement",
  "return Val": "Return Value",
  damagePer: "Damage Percentage",
  "visitCompliance Percentage": "Visit Compliance Percentage",
  plannedCall: "Planned Call",
  actualCall: "Actual Call",
  ptdMissed: "PTD Missed",
  l8WMissed: "Last 8 Week Missed",
  lwNotVisited_toggle: "Last Week not visited Toggle",
  ptdNotVisited_toggle: "PTD Not Visited Toggle",
  visit_compliance_lw_not_visited: "Visit Compliance Summary Card Heading",
  visit_compliance_per: "Visit Compliance Percentage",
  actualVisit: "Actual Visits",
  plannedVisit: "Planned Visits",
  missedVisit: "Missed Visits",
  lastVisitedOn: "Last Visited On",
  lastPlannedOn: "Last Planned On",
  ecoPercentage: "Eco Percentage",
  billedOutlet: "Billed Outlet",
  ptdNotBilled_toggle: "PTD Not Billed Toggle",
  eco_sm_card: "Eco Summary Card Heading",
  eco_compliance_percentage: "Eco Compliance Percentage",
  notBilledOutlet: "Not Billed Outlet",
  notBilledSince: "Not Billed Since",
  volume_tie_up: "Volume Tie Up Summary Card Heading",
  totalVolumeOutlets: "Total Volume Outlets",
  volumeTieUp100Ach: "Volume Tie Up 100% Ach",
};

export const ID_DESCRIPTION_MAP: Record<string, string> = {
  salesValue:
    "Highlights the sales target & achievement done by the user in the specific time ranges.",
  mslDistribution:
    "Highlights the sales target & achievement done by the user in the specific time ranges.",
  productiveCall:
    "Highlights the count of total planned calls & productive call achieved by the user.",
  visitCompliance:
    "Highlights the count of total planned calls, actual call achieved & calls missed by the user.",
  eco: "Gives visibility of the total Outlets & total billed outlets over a month/period.",
};

export const BUTTON_TABLE_MAP : Record<string,any>= {
  salesValue : {
    outlet_toggle : "sales_value_outlet_list",
    brand_toggle : "sales_value_brand_list",
  },
  mslDistribution : {

  },
  productiveCall : {
    outlet_toggle : "productive_call_outlet_list",
    day_toggle : "productive_call_day_list"
  },
  visitCompliance : {

    lwNotVisited_toggle : "visit_compliance_lw_list",
    ptdNotVisited_toggle : "visit_compliance_drill_down_list"
  },
  eco : {
    ptdNotBilled_toggle : "eco_drill_down_list"
  }
}